import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AddBrandService {

  constructor(private _http: HttpClient) { }

  addbrand(data) {
    return this._http.post(environment.api_url+'master/brand/add',data);
  }

  getcountry(data) {
    return this._http.post(environment.api_url+'master/countries/list',data);
  }

  searchcategory(data) {
    return this._http.post(environment.api_url+'searchcategory',data);
  }

}
